export function getMaxValue(data: { view: number; price: number }[], type: 'view' | 'price'): number {
	if (data.length === 0) return 0;

	return Math.max(...data.map(item => item[type]));
}

export function getMinValue(data: { view: number; price: number }[], type: 'view' | 'price'): number {
	if (data.length === 0) return 0;

	return Math.min(...data.map(item => item[type]));
}

export function formatBudget(budget: number): string {
	if (budget >= 1_000_000) {
		return `${budget / 1_000_000} میلیون تومان`;
	}
	if (budget >= 1_000) {
		return `${budget / 1_000} هزار تومان`;
	}
	return `${budget} تومان`;
}
